
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const WaterReadings = createAsyncThunk(
  "bill/WaterReading",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      let response;

      if (id) {
        // 🔵 Tenant side (Update)
        response = await axios.post(
          `${BASE_URL}/update-water-reading/${id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        // 🟢 Owner side (Create)
        response = await axios.post(
          `${BASE_URL}/water-reading`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



const WaterReading = createSlice({
    name: "WaterReading",
    initialState: {
        loading: false,
        WaterReading: [],
        error: ""
    },
    extraReducers: {
        [WaterReadings.fulfilled]: (state, action) => {
            state.WaterReading = action.payload;
            state.loading = false;
        },
        [WaterReadings.pending]: (state) => {
            state.loading = true;
        },
        [WaterReadings.rejected]: (state, action) => {
            state.error = action.error.message;
            state.loading = false;
        },
    }
});
export default WaterReading.reducer;
// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import { BASE_URL } from "../../config/config";


// export const WaterReadings = createAsyncThunk(
//   "dummyData/WaterReading",
//   async (id,formData, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/water-reading/${id}}`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             // Accept: "application/json",
//             // Authorization: "Bearer " + token,
//           },
//         }
//       );
      
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );




// const WaterReading = createSlice({
//   name: "waterReading",
//   initialState: {
//     loading: false,
//     data: null,
//     error: null,
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(WaterReadings.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(WaterReadings.fulfilled, (state, action) => {
//         state.loading = false;
//         state.data = action.payload;
//       })
//       .addCase(WaterReadings.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export default WaterReading.reducer;